import { ACTIVITY_ACTIONS, STATS_STATUS } from "@/constants";
import { localISODateString } from "@/utils/date";

function addActivity(activityDaily, log) {
  const date = log.createdUtc.split("T")[0];
  if (activityDaily[date]) {
    activityDaily[date].count++;
  } else {
    activityDaily[date] = { count: 1 };
  }
}

function findOpenLog(logs, from) {
  let i = from;
  while (i > -1) {
    const log = logs[i];
    if (log.action === ACTIVITY_ACTIONS.OPENED) {
      return log;
    }
    i--;
  }
}

export default {
  statsLogsAll(state) {
    return state.logs;
  },
  statsNotAsked(state) {
    return state.status === STATS_STATUS.NOT_ASKED;
  },
  statsLoading(state) {
    return state.status === STATS_STATUS.LOADING;
  },
  statsDateRange(state) {
    if (!state.query?.createdUtc) return null;
    const { from, to } = state.query.createdUtc;
    return { from, to };
  },
  statsDates(state) {
    const from = state.query?.createdUtc?.from;
    const to = state.query?.createdUtc?.to;
    const dateFrom = new Date(from);
    const dateTo = new Date(to);
    const dates = [];
    for (
      const date = dateFrom;
      date <= dateTo;
      date.setDate(date.getDate() + 1)
    ) {
      dates.push(localISODateString(date));
    }
    return dates;
  },
  statsAggregated(state, getters) {
    return getters.statsLogsAll.reduce(
      (stats, log) => {
        switch (log.action) {
          case ACTIVITY_ACTIONS.OPENED:
            stats.openedTotal++;
            addActivity(stats.openedDaily, log);
            break;
          case ACTIVITY_ACTIONS.UPDATED:
            stats.updatedTotal++;
            addActivity(stats.updatedDaily, log);
            break;
          case ACTIVITY_ACTIONS.REJECTED:
            stats.rejectedTotal++;
            addActivity(stats.rejectedDaily, log);
            break;
          case ACTIVITY_ACTIONS.CONFIRMED:
            stats.confirmedTotal++;
            addActivity(stats.confirmedDaily, log);
            break;
        }
        return stats;
      },
      {
        openedDaily: {},
        openedTotal: 0,
        updatedDaily: {},
        updatedTotal: 0,
        rejectedDaily: {},
        rejectedTotal: 0,
        confirmedDaily: {},
        confirmedTotal: 0
      }
    );
  },
  statsByEntity(state, getters) {
    return getters.statsLogsAll.reduce((stats, log) => {
      const { entityId } = log;
      if (!stats[entityId]) stats[entityId] = [];
      stats[entityId].push(log);
      return stats;
    }, {});
  },
  statsSpentTimes(state, getters) {
    return Object.values(getters.statsByEntity).reduce(
      (timeSpent, entityLogs) => {
        for (let [index, log] of entityLogs.entries()) {
          if (
            [ACTIVITY_ACTIONS.REJECTED, ACTIVITY_ACTIONS.CONFIRMED].includes(
              log.action
            )
          ) {
            const openLog = findOpenLog(entityLogs, index);
            const decisionTime =
              openLog &&
              Date.parse(log.createdUtc) - Date.parse(openLog.createdUtc);
            if (decisionTime && decisionTime > 0) timeSpent.push(decisionTime);
          }
        }
        return timeSpent;
      },
      []
    );
  },
  statsAvgDecisionTime(state, getters) {
    const times = getters.statsSpentTimes;
    const totalTime = times.reduce((total, time) => total + time, 0);
    return totalTime / times.length;
  }
};
